export default __webpack_public_path__ + "static/media/contextual-chocolate@2x.e06f6acb.png";